export const APP_UPDATE_FILTER = 'APP_UPDATE_FILTER';

export const updateFilter = filter => ({
	type: APP_UPDATE_FILTER,
	filter,
});



// WEBPACK FOOTER //
// ./src/actions/app.js